import RouterConfig from "./RouterConfig";
import {stockScreenerView, StockScreenerView} from "./view/StockScreenerViewComponent";

const ModuleName = "tfApp.stock-screener";

export default angular.module(ModuleName, [])
                      .config(RouterConfig)
                      .component(StockScreenerView, stockScreenerView())
    .name;
